import { Checkout } from '@df/checkout/checkout.interfaces';
import { GooglePay } from '@df/module-google-pay/google-pay.namespace';


export namespace NBarclaycardGooglePay {
    export enum EEndpoints {
        request = 'cyberSource/googlePay_request',
        shipping = 'cyberSource/googlePay_shipping',
        order = 'cyberSource/googlePay_place'
    }

    export const methodCode = 'cybersource_googlepay';

    export const version = 2;

    export const minorVersion = 0;

    export const notAvailableMessage = 'Google Pay is not available. Please select another payment method.';

    export interface IPaymentMethod extends Checkout.IPaymentMethod {
        isTest?: boolean;
        allowedCardTypes: GooglePay.TCardType[];
        merchantId: string;
        merchantName: string;
        gatewayId: string;
        gatewayMerchantId: string;
    }


    export interface IRequestSuccessResponse{
        success: boolean;
        request: IRequestSuccessResponseRequest
    }


    export interface IRequestSuccessResponseRequest {
        total: IRequestSuccessResponseRequestTotals;
        rates: GooglePay.ISelectionOption[];
        defaultSelectedOptionId: string;
    }

    export interface IRequestSuccessResponseRequestTotals {
        currencyCode: string;
        totalPrice: string;
        totalPriceStatus: GooglePay.TotalPriceStatusType;
    }
}
